"use strict";

/*
 * Tabellen aus dem Redaktionssystem bekommen die Bootstrap-Klassen.
 *
 * Am 2026-08-31 von jQuery auf natives JavaScript umgeschrieben. `table` auf
 * die Tabelle, `table-responsive` auf den Behaelter darum - das ist die Stelle,
 * an der Bootstrap waagerecht scrollen laesst.
 */

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("table").forEach((tabelle) => {
        tabelle.classList.add("table");

        if (tabelle.parentElement) {
            tabelle.parentElement.classList.add("table-responsive");
        }
    });
});
